import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Formik, Form } from "formik";
import { useSelector } from "react-redux";

// components
import Popdown from "./Popdown";
import {
  TextInput,
  SelectPeriodType,
  RollingDateSelect,
} from "components/form";
import SelectBranchForFilter from "./SelectBranchForFilter";
import SelectCoachForFilter from "./SelectCoachForFilter";
import { Button } from ".";
import IconButton from "./IconButton";

// assets
import CloseIcon from "assets/icons/close_icon.svg";

// utils
import { getCalendar } from "utils/date";

const PopdownFilter = ({
  visible,
  onClose,
  filter,
  setFilter,
  setSearchCount,
  filterType,
}) => {
  const { branchUseYn, seqPartnerBranch } = useSelector(
    (state) => state.partner
  );
  const childFunc = useRef(null);
  const [datePicker, setDatePicker] = useState({
    open: false,
    target: null,
    maxDate: "",
    minDate: ""
  });
  const resetDatePicker = () => setDatePicker({ open: false, target: null });
  const showBranchSelect = branchUseYn === "Y" && seqPartnerBranch === 0;

  const initialValues = {
    ...filter,
  };

  const handleDatePicker = (e, target, formValues) => {
    e.preventDefault();
    if (datePicker.open) {
      resetDatePicker();
      return;
    } else {
      let maxDate = ""
      let minDate = ""
      if(target === 'startDt') {
        maxDate = formValues.endDt
      }else {
        minDate = formValues.startDt 
      }
     
      setDatePicker({ open: true, target, maxDate, minDate  });
    }
  };

  useEffect(() => {
    resetDatePicker();
  }, [visible]);

  return (
    <Popdown open={visible} onClose={onClose} childFunc={childFunc}>
      <Wrapper smallHeight={filterType !== "coach" && !showBranchSelect}>
        <Title>
          <h4>검색하기</h4>
          <IconButton src={CloseIcon} onClick={(e) => childFunc.current(e)} />
        </Title>

        <Formik initialValues={initialValues}>
          {({ values, setFieldValue }) => (
            <Form>
              <DatePickerWrapper>
                <p
                  className="date"
                  onClick={(e) => handleDatePicker(e, "startDt", values)}
                >
                  {getCalendar(values.startDt, "yyyy.mm.dd")}
                </p>
                -
                <p
                  className="date"
                  onClick={(e) => handleDatePicker(e, "endDt", values)}
                >
                  {getCalendar(values.endDt, "yyyy.mm.dd")}
                </p>
              </DatePickerWrapper>

              {datePicker.open && (
                <RollingDateSelect
                  mode="days"
                  date={values[datePicker.target]}
                  maxDate={datePicker.maxDate}
                  minDate={datePicker.minDate}
                  resetDatePicker={resetDatePicker}
                  onChange={(date) => {
                    setFieldValue(datePicker.target, date);
                    setFieldValue("period", "");
                    resetDatePicker();
                  }}
                />
              )}

              <SelectPeriodType name="period" />

              {filterType === "coach" ? (
                <SelectCoachForFilter name="coachInfo" />
              ) : (
                showBranchSelect && (
                  <SelectBranchForFilter name="seqPartnerBranch" />
                )
              )}

              <TextInput
                name="searchTerm"
                placeholder="회원명 또는 전화번호를 입력하세요"
                marginBottom="16px"
                maxLength={50}
              />

              <ButtonWrapper>
                <Button
                  variant="contained"
                  className="square"
                  text="검색"
                  padding="16px"
                  onClick={(e) => {
                    setSearchCount((prev) => prev + 1);
                    setFilter(values);
                    childFunc.current(e);
                  }}
                />
              </ButtonWrapper>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </Popdown>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: ${(props) => (props.smallHeight ? "316px" : "364px")};
  padding: 16px 20px 24px 20px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const DatePickerWrapper = styled.div`
  width: 100%;
  height: 48px;
  border: 1px solid #e1e6ed;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  p.date {
    font-size: 16px;
    line-height: 24px;
    color: #26282b;
    text-align: center;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
`;
export default PopdownFilter;
